import styled, { css } from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";

interface IButtonIconWrapperProps {
    rotated45?: boolean;
    reverseOnRTL?: boolean;
}

export const ButtonIconWrapperBox = styled.span<IButtonIconWrapperProps>`
    ${props => props.rotated45 ? css`
        transform: rotate(-45deg);
    ` : null}

    ${props => props.reverseOnRTL ? css`
        ${CssRule.For.RTL.build()} &{
            transform: scaleX(-1);
        }
    ` : null}
`;
